<script lang="ts">
  import { alert } from '../store';
  import Dropzone from 'svelte-file-dropzone';
  import BackgroundImage from './BackgroundImage.svelte';

  interface ImageSelectEventDetail {
    acceptedFiles: File[];
  }

  export let ratio: string;
  export let src: string;
  export let file: File;

  function handleImageSelect(event: { detail: ImageSelectEventDetail }) {
    const { acceptedFiles } = event.detail;

    if (!acceptedFiles.length) {
      alert.show('Please select an image file!');
      return;
    }

    selectImage(acceptedFiles[0]);
  }

  async function selectImage(selectedImageFile: File) {
    file = selectedImageFile;
    src = await getImageFileSource(file);
  }

  async function getImageFileSource(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result as string);
      fileReader.onerror = reject;
      fileReader.onabort = reject;
      fileReader.readAsDataURL(file);
    });
  }
</script>

<div class="image-upload">
  <div class="drop-container">
    <Dropzone multiple={false} accept={['image/*']} on:drop={handleImageSelect} />
  </div>
  <div class="image-container">
    <BackgroundImage {src} {ratio} />
  </div>
</div>

<style lang="scss">
  .image-upload {
    display: flex;
    justify-content: space-between;
  }

  .drop-container {
    flex: 1;
    margin-right: 12px;
  }

  .image-container {
    flex: 1;
    margin-left: 12px;
  }

  :global(.dropzone) {
    height: 100%;
    justify-content: center;
  }
</style>
